module.exports = require("./fa-AF.js");